import { lazy, Suspense } from 'react';
import { useLang } from '@/lib/LanguageContext';
import { useLexique } from '@/lib/LexiqueContext';
import { ta } from '@/lib/i18n';
import { t } from '@/lib/translations';
import { ModalShell } from '@/components/shared/ModalShell';
import { ModalSkeleton } from '@/components/ui/ModalSkeleton';

/**
 * LexiqueModal — Océanne (wrapper modal pur).
 * Contenu délégué à LexiqueContent (single source).
 * Page SEO indexable : routes/lexique.tsx (LexiqueContent variant="page").
 *
 * Phase 27.84 — lazy-load LexiqueContent. Chunk dédié dans vite.config.ts.
 * ModalShell unmount son enfant quand isOpen=false ; le bundle ne s'évalue
 * qu'à la première ouverture. Le Schema.org DefinedTermSet JSON-LD du content
 * variant="page" est aussi présent en SSR via worker (route-meta.ts +
 * schema-org.ts), donc le SEO reste intact si lazy chunk encore non-chargé.
 */
const LexiqueContent = lazy(() =>
  import('./lexique-content').then((m) => ({ default: m.LexiqueContent }))
);

export function LexiqueModal() {
  const { lang } = useLang();
  const { isOpen, close } = useLexique();
  const text = ta(t.lexique, lang);

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={close}
      eyebrow={text.eyebrow}
      title={text.title}
      closeLabel={text.modal_close_label}
      ariaLabelledById="lexique-modal-title"
      printable
      printLabel={text.modal_print_label}
    >
      <Suspense fallback={<ModalSkeleton />}>
        <LexiqueContent variant="modal" onClose={close} />
      </Suspense>
    </ModalShell>
  );
}
